<template>

  <div class="color-picker">

    <div class="color-inputs">
      <div class="input-group">
        <input 
        type="color" 
        :value="value"
        @input="updateColorFromEvent"
        class="color-input form-control"
      >
        <input 
        type="text" 
        :value="value"
        :style="{ backgroundColor: value }"
        @input="updateColorFromEvent"
        placeholder="#000000"
        class="hex-input form-control"
      >
      <div class="input-group-append">
        <button class="btn btn-secondary" type="button" @click="togglePalette()">
          <i class="las la-palette"></i>
        </button>
      </div>
      </div>                            
    </div>
    
    <div class="color-palette" v-if="showPalette">
      <button type="button"
        v-for="color in colorPalette"
        :key="color"
        class="color-swatch"
        :style="{ backgroundColor: color }"
        :class="{ 'selected': value === color }"
        @click="updateColor(color)"
        :title="color"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: String,
      default: '#000000'
    }
  },
  data() {
    return {
      showPalette: false,
      colorPalette: [
        '#FF0000', // Red
        '#FF4500', // Orange Red
        '#FFA500', // Orange
        '#FFD700', // Gold
        '#FFFF00', // Yellow
        '#32CD32', // Lime Green
        '#008000', // Green
        '#00FFFF', // Cyan
        '#0000FF', // Blue
        '#4B0082', // Indigo
        '#800080', // Purple
        '#FF1493', // Deep Pink
        '#FFC0CB', // Pink
        '#FFFFFF', // White
        '#808080', // Gray
        '#000000', // Black
      ]
    }
  },
  methods: {
    updateColorFromEvent(event) {
      console.log('updateColorFromEvent', event.target.value);
      this.$emit('input', event.target.value);
      this.showPalette = false;
    },
    updateColor(color) {
      console.log('updateColor', color);
      this.$emit('input', color)
      this.showPalette = false;
    },
    togglePalette() {
      this.showPalette = !this.showPalette;
    }
  }
}
</script>

<style scoped>
.color-picker {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.color-display {
  height: 100px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.5);
}

.color-palette {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.color-swatch {
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s;
  position: relative;
}

.color-swatch:hover {
  transform: scale(1.1);
}

.color-swatch.selected {
  outline: 2px solid #333;
  outline-offset: 2px;
}

.color-inputs {
  display: flex;
  gap: 1rem;
}

.color-input {
  width: 30px;
  display: inline;
  padding: 0;
  border: none;
  cursor: pointer;
}

.hex-input {
  flex: 1;
  color: #fff;
}
</style>